<div class="gd-embed-twitter-dialog gd-global-material-dialog-padding"
  [dir]="dir$ | async">
  <form class="tw-flex tw-flex-col tw-justify-around tw-box-border"
    [formGroup]="embeddableForm"
    (ngSubmit)="save()"
    novalidate>
    <h2 class="mat-h2" i18n="Modal headline">Embed Twitter / X Post</h2>

    <section>
      <mat-form-field class="gd-embed-twitter-dialog__input-post-url"
        appearance="outline">
        <mat-label i18n>Post URL</mat-label>
        <input matInput
          type="text"
          formControlName="url"
          autocomplete="off">
          @if (urlControl.hasError('required')) {
            <mat-error i18n="Validation message">URL field cannot be blank.</mat-error>
          }
          @if (!urlControl.hasError('required') && urlControl.hasError('invalidUrl')) {
            <mat-error i18n="Validation message">Please insert a valid
          post URL.</mat-error>
          }
        </mat-form-field>
      </section>
      <section class="gd-embed-twitter-dialog__section-preview">
        <mat-card appearance="raised" class="gd-embed-twitter-dialog__post-preview"
          [class.post-loaded]="postLoaded">
          <div id="twitter-container"></div>
          <div class="gd-embed-twitter-dialog__loader">
            <mat-progress-bar mode="indeterminate"
            [style.opacity]="loading ? 1 : 0"></mat-progress-bar>
          </div>
        </mat-card>
      </section>

      <section class="gd-embed-twitter-dialog__section-buttons">
        <button mat-raised-button
          color="primary"
          type="submit"
          class="gd-embed-twitter-dialog-buttons--save"
        [disabled]="!postLoaded" i18n>Save</button>
        <button mat-raised-button
          color="danger"
        mat-dialog-close i18n>Cancel</button>
      </section>

    </form>

  </div>
